<template>
  <div class="postItem fCol jStart w33">
    <div class="thumb fullWidth fCol jCenter aCenter"
      v-if="data.medias[0].extensions === '.jpg'
        || data.medias[0].extensions === '.jpeg'
        || data.medias[0].extensions === '.png'"
      v-bind:style="{
        backgroundImage:
          `url('${baseURL}/socials/${data.medias[0].id}${data.medias[0].extensions}')`,
      }"
      @click="details = true"
      title="مشاهده‌ی پست"></div>
    <div class="thumb fullWidth fCol jCenter aCenter"
      v-if="data.medias[0].extensions === '.webm'
        || data.medias[0].extensions === '.mp4'
        || data.medias[0].extensions === '.MP4'"
      v-bind:style="{
        backgroundImage:
          `url('${baseURL}/socials/thumbnails/${data.medias[0].id}.jpg')`,
      }"
      @click="details = true"
      title="مشاهده‌ی پست">
    </div>
    <div class="fullWidth fRow jStart aCenter">
      <div class="avatar fRow jCenter aCenter"
        v-if="data.avatar === null">{{data.fullName.substr(0, 1)}}</div>
      <div class="avatar fRow jCenter aCenter"
        v-if="data.avatar !== null"
        v-bind:style="{
          backgroundImage:
          `url('${baseURL}/socials/${data.avatar}')`,
        }"></div>
      <div class="fCol jCenter aStart growFull">
        <div class="fullName">{{data.fullName}}</div>
        <div class="username">
          {{data.username === null ? `@user${data.id.substr(8, 5)}` : `@${data.username}`}}
        </div>
      </div>
    </div>
    <!-- type === 1 -->
    <div class="fRow jStart aCenter fullWidth" style="padding: 8px" v-if="type === 1">
      <div class="b fRow jCenter aCenter active"
        @click="changePostStatus(2)">
        <i class="material-icons-round">sync</i>
        <label>بررسی مجدد</label>
      </div>
      <div class="b fRow jCenter aCenter error"
        @click="changePostStatus(3)">
        <i class="material-icons-round">close</i>
        <label>رد پست</label>
      </div>
    </div>
    <!-- type === 2 -->
    <div class="fRow jStart aCenter fullWidth" style="padding: 8px" v-if="type === 2">
      <div class="b fRow jCenter aCenter active"
        @click="changePostStatus(1)">
        <i class="material-icons-round">done_all</i>
        <label>تأیید پست</label>
      </div>
      <div class="b fRow jCenter aCenter error"
        @click="changePostStatus(3)">
        <i class="material-icons-round">close</i>
        <label>رد پست</label>
      </div>
    </div>
    <!-- type === 3 -->
    <div class="fRow jStart aCenter fullWidth" style="padding: 8px" v-if="type === 3">
      <div class="b fRow jCenter aCenter active"
        @click="changePostStatus(2)">
        <i class="material-icons-round">sync</i>
        <label>بررسی مجدد</label>
      </div>
      <div class="b fRow jCenter aCenter active"
        @click="changePostStatus(1)">
        <i class="material-icons-round">done_all</i>
        <label>تأیید پست</label>
      </div>
    </div>
    <div class="dialog fCol jCenter aCenter" v-if="details">
      <div class="closer" @click="details = false"></div>
      <div class="box fCol jCenter aCenter">
        <!-- media slider -->
        <div class="fRow jCenter aCenter fullWidth">
          <i class="next material-icons-round"
            v-if="data.medias.length > 0"
            @click="nav('next')">
            keyboard_arrow_right
          </i>
          <div class="media growFull fCol jCenter aCenter">
            <img
              v-if="detailsData.extensions === '.jpg'
                || detailsData.extensions === '.jpeg'
                || detailsData.extensions === '.png'"
              :src="`${baseURL}/socials/${detailsData.id}${detailsData.extensions}`"
              alt="">
            <video
              controls
              v-if="detailsData.extensions === '.mp4'
                || detailsData.extensions === '.MP4'
                || detailsData.extensions === '.webm'"
              :src="`${baseURL}/socials/${detailsData.id}${detailsData.extensions}`"></video>
          </div>
          <i class="prev material-icons-round"
            v-if="data.medias.length > 0"
            @click="nav('prev')">
            keyboard_arrow_left
          </i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import errorHandler from '@/mixins/mixin';
import makeToast from '@/mixins/makeToast';

export default {
  props: ['data', 'type'],
  mixins: [errorHandler, makeToast],
  data() {
    return {
      details: false,
      detailsDataIndex: 0,
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
    };
  },
  computed: {
    detailsData() {
      return this.data.medias[this.detailsDataIndex];
    },
  },
  methods: {
    nav(to) {
      const a = this.data.medias.length;
      switch (to) {
        case 'next': {
          if (this.detailsDataIndex === a - 1) {
            this.detailsDataIndex = 0;
          } else {
            this.detailsDataIndex += 1;
          }
          break;
        }
        case 'prev': {
          if (this.detailsDataIndex === 0) {
            this.detailsDataIndex = a - 1;
          } else {
            this.detailsDataIndex -= 1;
          }
          break;
        }
        default:
          break;
      }
      console.log(this.detailsDataIndex);
    },
    changePostStatus(t) {
      axios({
        method: 'patch',
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
        url: `${this.baseURL}/api/v${this.V}/Socials/${this.data.id}?type=${t}`,
      }).then((response) => {
        // console.log('active/deactive access', response);
        if (response.data.isSuccess) {
          this.$emit('refresh');
          this.accessState = !this.accessState;
          switch (t) {
            case 1: {
              this.makeToast('success', 'پست مورد نظر تأیید شد', 2000);
              break;
            }
            case 2: {
              this.makeToast('success', 'دسترسی مورد در دسته‌ی بررسی مجدد ثبت شد', 2000);
              break;
            }
            case 3: {
              this.makeToast('success', 'پست مورد نظر رد شد', 2000);
              break;
            }
            default:
              break;
          }
        }
      }, (error) => {
        // console.log(error);
        this.makeToast('error', this.errorHandler(error), 2000);
      });
    },
  },
  mounted() {
    console.log(this.type);
  },
};
</script>

<style lang="scss" scoped>
  .postItem {
    box-shadow: 0 8px 16px -8px rgba($color: #000000, $alpha: 0.25);
    margin: 0 4px 8px;
    position: relative;
    .b.error {
      * {
        color: white;
      }
    }
    .thumb {
      height: 100px;
      font-size: 8px;
      background-color: rgba($color: #000000, $alpha: 0.05);
      cursor: pointer;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    }
    $ww: 32px;
    .avatar {
      width: $ww;
      height: $ww;
      min-width: $ww;
      border-radius: 50%;
      background-color: rgba($color: #000000, $alpha: 0.15);
      margin: 8px;
      line-height: 1;
      font-size: 10px;
    }
    .fullName {
      font-size: 12px;
      font-weight: bold;
    }
    .username {
      font-size: 10px;
      direction: ltr !important;
      font-weight: 200;
    }
    .dialog {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 200000000000;
      .closer {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 5;
        background-color: rgba($color: #000000, $alpha: 0.95);
      }
      .box {
        width: 90%;
        max-width: 850px;
        padding: 8px;
        z-index: 10;
        background-color: rgba($color: white, $alpha: 0.02);
        .media {
          height: 450px;
          img, video {
            max-width: 100%;
            max-height: 100%;
          }
        }
        i.prev, i.next {
          padding: 8px;
          border-radius: 50%;
          background-color: rgba($color: white, $alpha: 0.05);
          color: white;
          font-size: 16px;
          margin: 16px;
          cursor: pointer;
        }
      }
    }
  }
</style>
